interface WithId {
    id?: number;
    sort?: number;
}

function upgradeStore(dbReq: IDBOpenDBRequest, store: string) {
    return () => {
        const db = dbReq.result;
        const objectStore = db.createObjectStore(store, {keyPath: 'id'});
        objectStore.createIndex('id', 'id', {unique: false});
    };
}

export async function getFromDatabase<T>(store: string): Promise<T | null> {
    let db!: IDBDatabase;
    const databaseName = 'occasions';
    return new Promise(function (resolve, reject) {
        const dbReq = indexedDB.open(databaseName, 1);
        dbReq.onupgradeneeded = upgradeStore(dbReq, store);
        dbReq.onsuccess = function () {
            db = dbReq.result;
            if ([...db.objectStoreNames].find((name) => name === store)) {
                const transaction = db.transaction(store);
                const objectStore = transaction.objectStore(store);
                const getRequest = objectStore.getAll();
                getRequest.onerror = () => reject(getRequest.error);
                getRequest.onsuccess = () => resolve(getRequest.result as T);
                transaction.oncomplete = () => db.close();
            } else {
                indexedDB.deleteDatabase(store);
                resolve(null);
            }
        };
        dbReq.onerror = function (event) {
            console.error(`IndexedDB error: ${dbReq.error}`, event);
            reject(`IndexedDB error: ${dbReq.error}`);
        };
    });
}

export async function storeArrayInDatabase<T extends WithId>(store: string, values: T[]) {
    let db!: IDBDatabase;
    const editElement = <T>(store: string, key: string, payload: T) => {
        const open = indexedDB.open('occasions');
        return new Promise<T>((resolve, reject) => {
            open.onsuccess = () => {
                let request: IDBRequest;
                db = open.result;
                if ([...db.objectStoreNames].find((name) => name === store)) {
                    const transaction = db.transaction(store, 'readwrite');
                    const objectStore = transaction.objectStore(store);
                    if (key === 'all') request = objectStore.getAll();
                    else request = objectStore.get(key);
                    request.onerror = () => reject(request.error);
                    request.onsuccess = () => {
                        const serialized = JSON.parse(JSON.stringify(payload));
                        const updateRequest = objectStore.put(serialized);
                        updateRequest.onsuccess = () => resolve(request.result);
                    };
                    transaction.oncomplete = () => db.close();
                } else {
                    indexedDB.deleteDatabase('occasions');
                }
            };
        });
    };
    const request = indexedDB.open('occasions', 1);
    request.onerror = (err) => console.error(`IndexedDB error: ${request.error}`, err);
    request.onsuccess = () => {
        try {
            let index = 1;
            for (const value of values) {
                editElement('occasions', value.id?.toString() || '', {...value, sort: index++});
            }
        } catch (e) {
            console.error(e);
        }
    };
    request.onupgradeneeded = upgradeStore(request, store);
}
